import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetCollarQuery, GetCollarResponse } from "./type";

async function getCollars(query: GetCollarQuery): Promise<GetCollarResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.devices.collars.list;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetCollarResponse>(url);

  return response.data;
}

export function useGetCollars(
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-get-collars`, JSON.stringify(query ?? {})],
    () => getCollars(query ?? {}),
    mergedOptions,
  );
}
